import { styles } from "./DiscountPriceStyles";
import { Box } from "@ecco/ui/box";
import { Text } from "@ecco/ui/text";
import type { MoneyProps } from "@ecco/ui/money";
import { Money } from "@ecco/ui/money";

import type { JSX } from "react";

interface Props {
    priceProps: MoneyProps;
}

export const discountPrice = "discount-price";

const DiscountPrice = ({ priceProps }: Props): JSX.Element => {
    return (
        <Box sx={styles.container} alignItems="center" data-testid={discountPrice}>
            <Text
                fontSize={["mobileBodyTextNormal", "desktopBodyTextNormal"]}
                fontWeight="bold"
                as={"span"}
            >
                {" "}
                -{" "}
            </Text>
            <Money
                fontSize={["mobileBodyTextNormal", "desktopBodyTextNormal"]}
                fontWeight="bold"
                as={"span"}
                data-testid="discountprice"
                {...priceProps}
            />
        </Box>
    );
};

export default DiscountPrice;
